module.exports = __webpack_public_path__ + "img/CREDIT_CARD.c6d05960.svg";